import { useCallback } from "react";
import api from "../../services/api";
import { normalizeSettingsList } from "./settingsHelpers";

/** Una sola petición concurrente GET /settings (evita N filas → 429 y modal sin flags). */
let inFlightGetAll = null;

/** 0297 Fase B.1: caché en memoria (por pestaña) + TTL — evita N GET al montar N filas en lista. */
let cachedNormalizedList = null;
let cacheExpiresAt = 0;
/** @type {string | null} */
let cacheParamsKey = null;
const GET_ALL_CACHE_TTL_MS = 60 * 1000;

function clearGetAllCache() {
    cachedNormalizedList = null;
    cacheExpiresAt = 0;
    cacheParamsKey = null;
}

const useSettings = () => {
    const getAll = useCallback(async (params) => {
        const key =
            params === undefined || params === null
                ? ""
                : JSON.stringify(params);
        const now = Date.now();
        if (
            cachedNormalizedList !== null &&
            cacheExpiresAt > now &&
            cacheParamsKey === key
        ) {
            return cachedNormalizedList;
        }
        if (inFlightGetAll) {
            return inFlightGetAll;
        }
        inFlightGetAll = (async () => {
            try {
                const { data } = await api.request({
                    url: "/settings",
                    method: "GET",
                    params
                });
                const list = normalizeSettingsList(data);
                cachedNormalizedList = list;
                cacheExpiresAt = Date.now() + GET_ALL_CACHE_TTL_MS;
                cacheParamsKey = key;
                return list;
            } finally {
                inFlightGetAll = null;
            }
        })();
        return inFlightGetAll;
    }, []);

    const update = useCallback(async (data) => {
        const { data: responseData } = await api.request({
            url: `/settings/${data.key}`,
            method: "PUT",
            data
        });
        clearGetAllCache();
        return responseData;
    }, []);

    return {
        getAll,
        update
    };
};

export default useSettings;
export { normalizeSettingsList, isSettingTruthy } from "./settingsHelpers";